import { QueryResult } from 'react-query';
import { callApi, Controller, useApi, UseApiOptions } from './useApi';

export interface AngebotPosition {
    aNr: string;
    artikelGruppeNr: number;
    artikelNr: string;
    pos: number;
    posText: string;
    posEinh: string;
    posMenge: number;
    posEkPreis: number;
    posEPreis: number;
    posNetto: number;
    posMwst: number;
    posBrutto: number;
    posBem: string;
    posDoku: boolean;

    posEinh2: string;
    posEkPreis2: number;
    posEPreis2: number;

    posEinh3: string;
    posEkPreis3: number;
    posEPreis3: number;

    posEinh4: string;
    posEkPreis4: number;
    posEPreis4: number;

    updDat?: string;
    updUhr?: number;
    updUser?: string;

    transfer?: boolean;
    transferMenge?: number;
    transferLArt?: string;
}

export interface AngebotPositionFilter {
    aNrList?: string[];
    kNr?: number;
    aNr?: string;
    pos?: number;
}

export const defaultAngebotPosition: AngebotPosition = {
    aNr: '',
    artikelGruppeNr: 0,
    artikelNr: '',
    pos: -1, // -1 = new
    posText: '',
    posEinh: '',
    posMenge: 0,
    posEkPreis: 0,
    posEPreis: 0,
    posNetto: 0,
    posMwst: 20,
    posBrutto: 0,
    posBem: '',
    posDoku: true,

    posEinh2: '',
    posEkPreis2: 0,
    posEPreis2: 0,

    posEinh3: '',
    posEkPreis3: 0,
    posEPreis3: 0,

    posEinh4: '',
    posEkPreis4: 0,
    posEPreis4: 0,
};

export function useAngebotPositionList(
    filter: AngebotPositionFilter,
    apiOptions?: UseApiOptions<AngebotPosition[]>,
): QueryResult<AngebotPosition[]> {
    return useApi<AngebotPosition[]>(Controller.angebotPosition + '/list', { filter }, apiOptions);
}

interface AddAngebotPositionResult {
    newNr: number;
}

export async function addAngebotPosition(angebotPosition: AngebotPosition): Promise<AddAngebotPositionResult> {
    return callApi<AddAngebotPositionResult>(Controller.angebotPosition + '/add', { angebotPosition });
}

export async function updateAngebotPosition(angebotPosition: AngebotPosition): Promise<void> {
    return callApi<void>(Controller.angebotPosition + '/update', { angebotPosition });
}

export async function deleteAngebotPosition(angebotPosition: AngebotPosition): Promise<void> {
    return callApi<void>(Controller.angebotPosition + '/delete', { angebotPosition });
}

export async function moveUpAngebotPosition(aNr: string, pos: number): Promise<void> {
    return callApi<void>(Controller.angebotPosition + '/moveup', {
        angebotPosition: {
            aNr,
            pos,
        },
    });
}
